import { Navigate, Route, Routes } from "react-router-dom";

import AppLayout from "./components/AppLayout";
import RequireAuth from "./components/RequireAuth";
import Login from "./routes/Login";
import Dashboard from "./routes/Dashboard";
import EmployeeDetail from "./routes/EmployeeDetail";
import AdminUsers from "./routes/admin/Users";
import AdminEmployees from "./routes/admin/Employees";
import CheckIn from "./routes/CheckIn";
import OrgTree from "./routes/OrgTree";
import Documents from "./routes/Documents";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/checkin/:token" element={<CheckIn />} />
      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/employees/:oracleId" element={<EmployeeDetail />} />
        <Route path="/org" element={<OrgTree />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/employees" element={<AdminEmployees />} />
        <Route path="/admin/users" element={<AdminUsers />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
